<template>
  <div :class="['header-state-message js-banner', colorClass]">
    <div class="header-state-message__container">
      <slot name="message"></slot>
      <oie-impersonating-slide-in v-if="clientModel.impersonating"></oie-impersonating-slide-in>
      <button class="header-state-message__action" @click="()=> $emit('click')">
        <slot name="button-text"></slot>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    color: {
      type: String,
      default: 'purple'
    }
  },
  computed: {
    colorClass() {
      return `header-state-message--${this.color}`
    }
  }
}
</script>

<style lang="scss">
.header-state-message {
  position: relative;
  z-index: 1;
}

// Todo: colors() did not work. Find better solution for setting colors.
.header-state-message--purple {
  --bg-color: #7264AF;
  --text-color: #FFFFFF;
}

.header-state-message--green {
  --bg-color: #239B58;
  --text-color: #FFFFFF;
}

.header-state-message {
  background-color: var(--bg-color);
  color: var(--text-color)
}

.header-state-message__container {
  @include container;
  @include body-smaller-semi-bold;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 2.25rem;
  padding-top: measure(quarter);
  padding-bottom: measure(quarter);

  @include media(small) {
    flex-direction: row;
    justify-content: space-between;
  }

  @include media(medium) {
    justify-content: center;
  }
}

.header-state-message__action {
  @include reset-button;
  flex-shrink: 0;
  margin-top: measure(eighth);
  padding: measure(eighth) measure(half);
  background-color: transparent;
  color: var(--text-color);
  border: 1px solid var(--text-color);
  border-radius: 0.8125rem;
  transition: all 140ms ease-in;

  @include media(small) {
    margin-top: 0;
  }

  @include media(medium) {
    position: absolute;
    top: 50%;
    right: measure(half);
    transform: translateY(-50%);
  }

  &:hover {
    background-color: var(--text-color);
    color: var(--bg-color);
    transition: all 140ms ease-out;
  }
}

.header-state-message__action >:not(:last-child) {
  margin-right: measure(eighth);
}
</style>
